import { nextTick, ref, reactive, getCurrentInstance } from "vue";
import BpmnViewer from "bpmn-js/lib/Viewer";
import { xmlStr } from "@/constants";
import { queryProcessTable } from "@/api/processInitiation";

export default function useProcessInitiationTable() {
  const { proxy } = getCurrentInstance();
  // loading
  const loading = ref(true);

  // 流程list
  const processList = ref([]);

  // 流程实例
  const bpmnInstances = ref([]);

  // 所属系统
  const processSystem = ref(null);

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 发起流程对象
  const adjustRef = ref(null);

  // 点击菜单
  const handleMenu = (index) => {
    if (defaultActive.value == index) return;
    getList();
  };

  // 获取流程模型列表
  const getList = () => {
    loading.value = true;
    queryProcessTable({
      page: pages.page,
      limit: pages.limit,
      processSystem,
    })
      .then((res) => {
        processList.value = res.data.records || [];
        pages.total = res.data.total;
      })
      .finally(() => {
        // 防止出现重新调用接口时 页面渲染出多个相同svg的问题
        if (bpmnInstances.value.length > 0) {
          bpmnInstances.value.forEach((item) => {
            item.destroy();
          });
          // 清空实例数组
          bpmnInstances.value = [];
        }
        for (let i = 0; i < processList.value.length; i++) {
          // const canvas = document.getElementById(`prefix_${i}`);
          const canvas = proxy.$refs[`prefix_${i}`][0];
          console.log("cccc", canvas);
          let bpmnViewer = new BpmnViewer({
            container: canvas,
          });
          bpmnInstances.value.push(bpmnViewer);
          // 使用旧版本的语法，新版本的promise语法存在svg不在dom元素正中的问题
          bpmnViewer.importXML(
            // xmlStr,
            processList.value[i].processXmlStr || xmlStr,
            (function (bpmnViewer) {
              return function (err) {
                if (!err) {
                  console.log("success!");
                  // 让图能自适应屏幕
                  const canvas = bpmnViewer.get("canvas");
                  canvas.zoom("fit-viewport", "auto");
                } else {
                  console.log("something went wrong:", err);
                }

                // document.getElementsByClassName("bjs-powered-by")[0].style.display = 'none'
                const arr =
                  window.appDocument.getElementsByClassName("bjs-powered-by");
                for (let j = 0; j < arr.length; j++) {
                  arr[j].style.display = "none";
                }

                // 隐藏bpmn 图标
                const arr2 =
                  window.appDocument.getElementsByClassName("bjs-breadcrumbs");
                for (let h = 0; h < arr2.length; h++) {
                  arr2[h].style.display = "none";
                }
              };
            })(bpmnViewer)
          );
        }
        loading.value = false;
      });
  };

  // 点击card
  const startProcessById = (item) => {
    adjustRef.value?.handleDialogOpen(item);
  };
  return {
    loading,
    processList,
    adjustRef,
    handleMenu,
    getList,
    startProcessById,
  };
}
